import React from 'react';
import { EditableField } from './EditableField';
export interface EstimatedCosts {
  miscBoxAB: number;
  ourFee: number;
  discountRebate: number;
  attorneyTitle: number;
  fundingFee: number | null;
  totalCost: number;
  breakeven: number;
}
interface CostBreakdownProps {
  costs: EstimatedCosts;
  onChange: (key: keyof EstimatedCosts, value: number | null) => void;
}
export function CostBreakdown({
  costs,
  onChange
}: CostBreakdownProps) {
  return <div className="bg-gray-50 rounded-lg p-4 border border-gray-100" data-id="element-12">
      <h4 className="text-sm font-semibold text-gray-900 mb-3 uppercase tracking-wider" data-id="element-13">
        Estimated Costs
      </h4>

      <div className="space-y-2 text-sm" data-id="element-14">
        <div className="flex justify-between items-center py-1 border-b border-gray-200 border-dashed" data-id="element-15">
          <span className="text-gray-600" data-id="element-16">Misc Box A/B</span>
          <EditableField value={costs.miscBoxAB} type="currency" onSave={val => onChange('miscBoxAB', val)} className="font-medium" data-id="element-17" />
        </div>
        <div className="flex justify-between items-center py-1 border-b border-gray-200 border-dashed" data-id="element-18">
          <span className="text-gray-600" data-id="element-19">Our Fee</span>
          <EditableField value={costs.ourFee} type="currency" onSave={val => onChange('ourFee', val)} className="font-medium" data-id="element-20" />
        </div>
        <div className="flex justify-between items-center py-1 border-b border-gray-200 border-dashed" data-id="element-21">
          <span className="text-gray-600" data-id="element-22">Discount/Rebate</span>
          <EditableField value={costs.discountRebate} type="currency" isNegativeRed={true} onSave={val => onChange('discountRebate', val)} className="font-medium" data-id="element-23" />
        </div>
        <div className="flex justify-between items-center py-1 border-b border-gray-200 border-dashed" data-id="element-24">
          <span className="text-gray-600" data-id="element-25">Attorney/Title</span>
          <EditableField value={costs.attorneyTitle} type="currency" onSave={val => onChange('attorneyTitle', val)} className="font-medium" data-id="element-26" />
        </div>
        <div className="flex justify-between items-center py-1 border-b border-gray-200 border-dashed" data-id="element-27">
          <span className="text-gray-600" data-id="element-28">Funding Fee</span>
          <EditableField value={costs.fundingFee} type="currency" onSave={val => onChange('fundingFee', val)} className="font-medium" data-id="element-29" />
        </div>

        <div className="flex justify-between items-center pt-2 mt-2" data-id="element-30">
          <span className="font-bold text-gray-900" data-id="element-31">Total Cost</span>
          <EditableField value={costs.totalCost} type="currency" onSave={val => onChange('totalCost', val)} className="font-bold text-gray-900 text-base" data-id="element-32" />
        </div>
      </div>
    </div>;
}